import {
  collection,
  doc,
  setDoc,
  deleteDoc,
  query,
  where,
  getDocs,
  getDoc,
  Timestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import { getArtworkById } from './artworkService';
import { Artwork } from '../types';

export const addToWishlist = async (userId: string, artworkId: string) => {
  const wishlistRef = doc(db, 'wishlists', `${userId}_${artworkId}`);
  await setDoc(wishlistRef, {
    userId,
    artworkId,
    addedAt: Timestamp.now(),
  });
};

export const removeFromWishlist = async (userId: string, artworkId: string) => {
  const wishlistRef = doc(db, 'wishlists', `${userId}_${artworkId}`);
  await deleteDoc(wishlistRef);
};

export const isInWishlist = async (userId: string, artworkId: string): Promise<boolean> => {
  const wishlistRef = doc(db, 'wishlists', `${userId}_${artworkId}`);
  const wishlistDoc = await getDoc(wishlistRef);
  return wishlistDoc.exists();
};

export const getWishlistArtworks = async (userId: string): Promise<Artwork[]> => {
  const q = query(
    collection(db, 'wishlists'),
    where('userId', '==', userId)
  );

  const querySnapshot = await getDocs(q);
  const artworkIds = querySnapshot.docs.map(doc => doc.data().artworkId);

  const artworkPromises = artworkIds.map(id => getArtworkById(id));
  const artworks = await Promise.all(artworkPromises);

  return artworks.filter(artwork => artwork !== null) as Artwork[];
};